import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Kill switch: unregister any zombie service worker from an older version
// of the site, and clear its caches. Prevents fetch interception errors like
// "Failed to execute 'clone' on 'Response': Response body is already used".
if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .getRegistrations()
    .then((registrations) => {
      registrations.forEach((reg) => reg.unregister());
    })
    .catch(() => {});
}
if (typeof caches !== "undefined") {
  caches
    .keys()
    .then((keys) => Promise.all(keys.map((k) => caches.delete(k))))
    .catch(() => {});
}

const rootElement = document.getElementById("root");

// Create React root and render the app
// This will replace the pre-rendered HTML content
const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
